import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { update } from "../../../state/bordersSlice";
import { Button, makeStyles } from "@fluentui/react-components";
import { LineTypeSolid, LineTypeDashed, LineTypeDotted } from "../../../assets/icons";

const useClasses = makeStyles({
  Header: {
    fontFamily: "Arial",
    fontSize: 10,
    fontWeight: 700,
    lineGeight: 11.5,
    textAlign: "left",
  },
  PanelButton: {
    justifyContent: "left",
    fontFamily: "Arial",
    fontSize: 9,
    fontWeight: 400,
    letterSpacing: "0.02em",
  },
  AccordionHeader: {
    "& > button": {
      minHeight: 0,
    },
  },
});

const BorderTypeMenuItem = () => {
  const classes = useClasses();
  const { t } = useTranslation();
  const selection = useSelector((state) => state.selection.borders[0]);
  const selectedBorder = useSelector((state) => state.gridd.present.borders.find((b) => b.id === selection.id));
  const dispatch = useDispatch();

  return (
    <div>
      <div style={{ display: "grid", gridTemplateRows: "auto auto auto" }}>
        <Button
          id="solid"
          icon={<LineTypeSolid />}
          appearance="subtle"
          className={classes.PanelButton}
          onClick={() => {
            dispatch(update({ id: selectedBorder.id, style: "solid" }));
          }}
        >
          {t("menu.border.type.solid")}
        </Button>
        <Button
          id="dashed"
          icon={<LineTypeDashed />}
          appearance="subtle"
          className={classes.PanelButton}
          onClick={() => {
            dispatch(update({ id: selectedBorder.id, style: "dashed" }));
          }}
        >
          {t("menu.border.type.dashed")}
        </Button>
        <Button
          id="dotted"
          icon={<LineTypeDotted />}
          appearance="subtle"
          className={classes.PanelButton}
          onClick={() => {
            dispatch(update({ id: selectedBorder.id, style: "dotted" }));
          }}
        >
          {t("menu.border.type.dotted")}
        </Button>
      </div>
    </div>
  );
};

export default BorderTypeMenuItem;
